import dynamic from 'next/dynamic';
import { CardSummaryProps } from './CardSummary.types';

export const CardSummaryDynamic = dynamic<CardSummaryProps>(() =>
  import('./CardSummary').then(module => module.CardSummaryNonEditable)
);
export { CardSummaryNonEditable, CardSummary, CardSummaryConfig } from './CardSummary';
